import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"


import ListColumn from "./ListColumn.vue";
import ListRowWrap from "./ListRowWrap.vue";

interface IProps {
  columns: {
    header: string;
    text: string;
  }[];
  vertical?: boolean;
  halfGap?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ListRow',
  props: {
    columns: {},
    vertical: { type: Boolean },
    halfGap: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ListRowWrap, {
    vertical: _ctx.vertical,
    "half-gap": _ctx.halfGap
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
        return (_openBlock(), _createBlock(ListColumn, {
          header: column.header,
          text: column.text,
          key: _ctx.columns.indexOf(column)
        }, null, 8, ["header", "text"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["vertical", "half-gap"]))
}
}

})